import React, { useState, useEffect } from 'react';

const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&q=80&w=800';

const ProductImage = ({ src, alt, className = "" }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [imgSrc, setImgSrc] = useState(src);

    useEffect(() => {
        // Normalize src
        let cleanSrc = (src && src !== 'null' && src !== 'undefined') ? src : FALLBACK_IMAGE;

        // If it's a relative path (local upload), prepend the API URL
        if (cleanSrc.startsWith('/uploads')) {
            const baseUrl = import.meta.env.VITE_API_URL || window.location.origin;
            const cleanBaseStart = baseUrl.replace(/\/api$/, '');
            cleanSrc = `${cleanBaseStart}${cleanSrc}`;
        }

        // Only reset loading if the SOURCE actually changes (and it's not just a re-render)
        if (cleanSrc !== imgSrc) {
            setImgSrc(cleanSrc);
            setLoading(true);
            setError(false);
        }

        if (cleanSrc === FALLBACK_IMAGE) {
            setLoading(false);
        }
    }, [src, imgSrc]); // Added imgSrc dependency to prevent loop/stale closures

    const handleError = () => {
        setError(true);
        setLoading(false);
        setImgSrc(FALLBACK_IMAGE);
    };

    const handleLoad = () => {
        setLoading(false);
    };

    return (
        <div className={`relative overflow-hidden bg-gray-900/50 ${className}`}>
            {loading && (
                <div className="absolute inset-0 z-10 animate-pulse bg-gray-800">
                    {/* Custom loading effect */}
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent skew-x-12 -translate-x-full animate-[shimmer_2s_infinite]"></div>
                </div>
            )}

            <img
                src={imgSrc || FALLBACK_IMAGE}
                alt={alt}
                loading="lazy"
                decoding="async"
                className={`w-full h-full object-cover transition-all duration-700 ${loading ? 'opacity-0 scale-105' : 'opacity-100 scale-100'
                    }`}
                onLoad={handleLoad}
                onError={handleError}
            />

            {error && !loading && (
                <div className="absolute bottom-2 right-2 bg-black/60 backdrop-blur-sm px-2 py-1 rounded text-[10px] text-white/50 uppercase tracking-widest">
                    Fallback
                </div>
            )}
        </div>
    );
};

export default ProductImage;
